import React from 'react'
import NavbarOne from './separate/NavbarOne'
import Footer from './separate/Footer'
import SubBrokerScene from './separate/SubBrokerScene'
import {
  LuUsers,
  LuIndianRupee,
  LuGlobe,
  LuFileCheck,
  LuLaptop,
  LuBuilding2,
  LuUserCheck,
  LuCheckCircle2,
  LuArrowRight,
  LuWallet,
  LuClock,
  LuShield,
  LuHeartHandshake,
} from 'react-icons/lu'
import { Link, useNavigate } from 'react-router-dom'
import CustomChip from '../Component/CustomChip/CustomChip'
import PageTitleDes from '../core/support/PageTitleDes'

// Mock Handshake icon if not available in older react-icons/lu, otherwise import it.
// Using LuHeartHandshake as fallback/placeholder.
const LuHandshake = LuHeartHandshake

const benefits = [
  {
    icon: LuIndianRupee,
    title: 'Lifelong Commission',
    description:
      'Earn recurring commission for the entire duration of your contract with Unitic Exchange. Your referrals = Your passive income.',
  },
  {
    icon: LuGlobe,
    title: 'Regional Expansion',
    description:
      'Represent Unitic Exchange in your region. Build your network and grow your influence in the crypto trading community.',
  },
  {
    icon: LuLaptop,
    title: '100% Remote Setup',
    description:
      'No physical office required. Work from anywhere with just your laptop and internet connection.',
  },
  {
    icon: LuFileCheck,
    title: 'Simple Onboarding',
    description:
      'Get started with minimal documentation. Quick verification process to become an official Sub-Broker.',
  },
]

const commissionTiers = [
  {
    type: 'Individual Referrals',
    icon: LuUserCheck,
    commission: 'Up to 40%',
    description:
      'Commission on trading fees from individual traders you onboard',
    color:
      'linear-gradient(135deg, rgba(29, 160, 148, 0.2), rgba(29, 160, 148, 0.05))',
  },
  {
    type: 'Institutional Referrals',
    icon: LuBuilding2,
    commission: 'Up to 50%',
    description:
      'Higher commission rates for institutional clients and high-volume traders',
    color:
      'linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 0.05))',
  },
]

const steps = [
  {
    step: '01',
    title: 'Apply Online',
    description:
      'Fill out our simple application form with your basic details and regional preference.',
  },
  {
    step: '02',
    title: 'Submit Documents',
    description:
      'Upload identity proof, address verification, and bank details for commission payouts.',
  },
  {
    step: '03',
    title: 'Get Verified',
    description:
      'Our team reviews your application within 48 hours and approves eligible candidates.',
  },
  {
    step: '04',
    title: 'Start Earning',
    description:
      'Receive your unique referral code and start onboarding users to earn commission.',
  },
]

const requirements = [
  'Valid government-issued ID proof',
  'Address verification document',
  'Bank account for commission payouts',
  'Basic understanding of crypto trading',
  'Strong local network (optional but beneficial)',
]

const stats = [
  { value: '5+', label: 'Subbroker' },
  { value: '₹2Cr+', label: 'Instant Commission' },
  { value: '50+', label: 'Multi Regions' },
  { value: '48hrs', label: '48hrs Avg-Approval' },
]

function SubBroker() {
  const navigate = useNavigate()
  return (
    <div
      className='bg-default text-white'
      style={{ overflowX: 'hidden', backgroundColor: '#0B0E14' }}
    >
      <PageTitleDes title={`Crypto Sub Broker Program | Earn with Referral & Partner Network`} description={` Join our Sub Broker Program and grow your income through crypto referrals. Build your network, earn commissions, and expand your business with ease.`} />
      <NavbarOne />

      {/* Hero Section */}
      <section
        className='position-relative pt-5 pb-5'
        style={{ minHeight: 'calc(80vh - 10px)', overflow: 'hidden' }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(to bottom, rgba(29, 160, 148, 0.05), transparent)',
            zIndex: 0,
          }}
        />
        {/* Background Blobs */}
        <div
          style={{
            position: 'absolute',
            top: '25%',
            left: '0',
            width: '384px',
            height: '384px',
            background: 'rgba(29, 160, 148, 0.1)',
            borderRadius: '50%',
            filter: 'blur(100px)',
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '25%',
            right: '25%',
            width: '320px',
            height: '320px',
            background: 'rgba(16, 185, 129, 0.1)',
            borderRadius: '50%',
            filter: 'blur(100px)',
            zIndex: 0,
          }}
        />

        <div className='container position-relative z-1 pt-5'>
          <div className='row align-items-center gy-5'>
            {/* Left Content */}
            <div className='col-lg-6 text-start'>
              <CustomChip>
                <LuHandshake
                  className='text-primary'
                  style={{ color: '#1da094' }}
                />
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#1da094',
                  }}
                >
                  Partner Program
                </span>
              </CustomChip>
              <h1
                className='fw-bold mb-4'
                style={{
                  fontSize: 'clamp(2rem, 5vw, 4rem)',
                  lineHeight: 1.1,
                }}
              >
                Become a <span style={{ color: '#1da094' }}>Sub-Broker</span>
                <br />
                Earn Lifelong Commission
              </h1>

              <p
                className='mb-5'
                style={{
                  color: '#9AA6B2',
                  fontSize: 'clamp(0.875rem, 1rem, 1.125rem)',
                  maxWidth: '550px',
                }}
              >
                Represent Unitic Exchange in your region. Onboard traders and
                earn recurring commission for as long as you're in contract with
                us. No office needed – just your network.
              </p>

              <div className='d-flex flex-column flex-sm-row gap-3 mb-5'>
                <button
                  className='btn-earn-hero'
                  onClick={() => {
                    document.getElementById('apply')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Apply Now <LuArrowRight size={20} className='ms-2' />
                </button>
                <button onClick={() => { document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' }) }} className='btn-earn-hero-outline'
                >
                  Learn More
                </button>
              </div>

              {/* Stats */}
              <div className='row g-4'> {stats.map((stat) => (<div key={stat.label} className='col-6 col-md-3 text-start'> <div className='fw-bold mb-1 sb-state-value' style={{ color: '#1da094' }} > {stat.value} </div> <div className='small' style={{ color: '#9AA6B2' }}> {stat.label} </div> </div>))} </div>
            </div>

            {/* Right Scene */}
            <div className='col-lg-6 d-none d-lg-flex align-items-center justify-content-center'>
              <div
                className='position-relative'
                style={{ height: '500px', width: '100%' }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'linear-gradient(135deg, rgba(29, 160, 148, 0.1), rgba(16, 185, 129, 0.1))',
                    borderRadius: '50%',
                    filter: 'blur(80px)',
                    zIndex: 0,
                  }}
                />
                <div
                  style={{
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <SubBrokerScene />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section
        className='py-5'
        style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}
      >
        <div className='container py-5'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>Why Become a Sub-Broker?</h2>
            <p className='text-muted-foreground mb-4'>
              Join our growing network of partners and unlock unlimited earning
              potential
            </p>
          </div>
          <div className='row g-4'>
            {benefits.map((benefit) => (
              <div key={benefit.title} className='col-md-6 col-lg-3'>
                <div
                  className='h-100 p-4 rounded-4'
                  style={{
                    backgroundColor: '#0B0E14',
                    border: '1px solid rgba(255,255,255,0.1)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <div
                    className='d-flex align-items-center justify-content-center mb-4 rounded-3'
                    style={{
                      width: '48px',
                      height: '48px',
                      background: 'rgba(29, 160, 148, 0.1)',
                      color: '#1da094',
                    }}
                  >
                    <benefit.icon size={24} />
                  </div>
                  <h3 className='h5 fw-bold mb-2'>{benefit.title}</h3>
                  <p className='small mb-0' style={{ color: '#9AA6B2' }}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Commission Structure */}
      <section className='py-5'>
        <div className='container py-5'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>Attractive Commission Structure</h2>
            <p className='text-muted-foreground mb-4'>
              Earn competitive commission rates on every trade made by your
              referred users
            </p>
          </div>
          <div className='row justify-content-center g-4 mb-5'>
            {commissionTiers.map((tier) => (
              <div
                key={tier.type}
                className='col-12 col-sm-10 col-md-6 tier-col'
              >
                <div
                  className='tier-card p-4 p-md-5 rounded-4 position-relative overflow-hidden h-100'
                  style={{
                    background: tier.color,
                    border: '1px solid rgba(255,255,255,0.1)',
                  }}
                >
                  <div className='tier-blur' />

                  <div className='position-relative z-1'>
                    <div className='tier-icon d-flex align-items-center justify-content-center mb-3 mb-md-4 rounded-3 shadow'>
                      <tier.icon className='tier-icon-svg' />
                    </div>

                    <h3 className='tier-title fw-semibold mb-2'>
                      {tier.type}
                    </h3>

                    <div className='tier-commission fw-bold mb-2 mb-md-3'>
                      {tier.commission}
                    </div>

                    <p className='tier-desc'>
                      {tier.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Highlights */}
          <div className='row justify-content-center g-4'>
            <div className='col-md-4'>
              <div
                className='d-flex align-items-center gap-3 p-4 rounded-4'
                style={{
                  background: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <LuClock size={32} style={{ color: '#1da094' }} />
                <div>
                  <div className='fw-semibold'>Monthly Payouts</div>
                  <div className='small' style={{ color: '#9AA6B2' }}>
                    Timely commission transfers
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div
                className='d-flex align-items-center gap-3 p-4 rounded-4'
                style={{
                  background: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <LuWallet size={32} style={{ color: '#1da094' }} />
                <div>
                  <div className='fw-semibold'>No Earning Cap</div>
                  <div className='small' style={{ color: '#9AA6B2' }}>
                    Unlimited income potential
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div
                className='d-flex align-items-center gap-3 p-4 rounded-4'
                style={{
                  background: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <LuShield size={32} style={{ color: '#1da094' }} />
                <div>
                  <div className='fw-semibold'>Lifetime Contract</div>
                  <div className='small' style={{ color: '#9AA6B2' }}>
                    Earn as long as you partner
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section
        id='how-it-works'
        className='py-2'
        style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}
      >
        <div className='container px-4 px-md-3 py-5'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>How to Get Started</h2>
            <p className='text-muted-foreground mb-4'>
              Simple 4-step process to become an official Unitic Sub-Broker
            </p>
          </div>

          <div className='row g-4 mb-5'>
            {steps.map((step, index) => (
              <div
                key={step.step}
                className='col-md-6 col-lg-3 position-relative'
              >
                <div
                  className='fw-bold mb-3 sb-steps-points'
                  style={{ color: '#1da094' }}
                >
                  {step.step}
                </div>
                <h3 className='h5 fw-semibold mb-2 sb-steps-title'>{step.title}</h3>
                <p className='small' style={{ color: '#9AA6B2' }}>
                  {step.description}
                </p>
              </div>
            ))}
          </div>

          {/* Requirements */}
          <div className='row justify-content-center'>
            <div className='col-lg-8'>
              <div
                className='p-5 rounded-4'
                style={{
                  backgroundColor: '#0B0E14',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <h3 className='h5 fw-semibold text-center mb-4'>
                  Documents Required
                </h3>
                <div className='d-flex flex-column gap-3'>
                  {requirements.map((req) => (
                    <div key={req} className='d-flex align-items-center gap-3'>
                      <LuCheckCircle2
                        size={20}
                        style={{ color: '#1da094', flexShrink: 0 }}
                      />
                      <span style={{ color: '#9AA6B2' }}>{req}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id='apply' className='py-5'>
        <div className='container py-5'>
          <div
            className='p-5 rounded-4 text-center mx-auto'
            style={{
              background:
                'linear-gradient(135deg, rgba(29, 160, 148, 0.1), #0B0E14, rgba(16, 185, 129, 0.05))',
              border: '1px solid rgba(29, 160, 148, 0.2)',
              maxWidth: '800px',
            }}
          >
            <div
              className='d-flex align-items-center justify-content-center mx-auto mb-4 rounded-3'
              style={{
                width: '64px',
                height: '64px',
                background: 'rgba(29, 160, 148, 0.2)',
              }}
            >
              <LuUsers size={32} style={{ color: '#1da094' }} />
            </div>
            <h2
              className='fw-bold mb-3'
              style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}
            >
              Ready to Partner with Unitic?
            </h2>
            <p
              className='mx-auto mb-5 sb-ready-desc'
              style={{ color: '#9AA6B2', maxWidth: '500px' }}
            >
              Join our network of successful sub-brokers earning lifelong
              commission. No office, no overhead – just your expertise and
              network.
            </p>
            <div className='d-flex flex-column flex-sm-row justify-content-center gap-3'>
              <button
                onClick={() => navigate('/help-center')}
                className='btn d-flex align-items-center justify-content-center gap-2 py-2 py-md-3 px-3 px-md-4 btn-earn-hero'
                style={{
                  backgroundColor: '#1da094',
                  color: '#fff',
                  borderRadius: '12px',
                  fontWeight: 600,
                  // fontSize: '1.1rem',
                  border: 'none',
                }}
              >
                Apply as Sub-Broker <LuArrowRight size={20} />
              </button>
              <Link
                to='/'
                className='btn d-flex align-items-center justify-content-center py-2 py-md-3 px-3 px-md-4 btn-earn-hero-outline'
                style={{
                  backgroundColor: 'transparent',
                  color: '#fff',
                  borderRadius: '12px',
                  fontWeight: 600,
                  // fontSize: '1.1rem',
                  border: '1px solid rgba(255,255,255,0.2)',
                  textDecoration: 'none',
                }}
              >
                Back to Home
              </Link>
            </div>
            <p className='small mt-4 mb-0' style={{ color: '#9AA6B2' }}>
              Applications are reviewed within 48 hours. T&C apply.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default SubBroker
